export const blocksAgencyUnitDetails = (auth, project, unit) => {
  const branch = auth && auth.affiliate && auth.affiliate.companyBranch;
  return Boolean(branch && branch.isExternal
    && project && project.agencyAllocationAllocateAll === false
    && unit && (unit.statusID === 'unavailable'
      || (project.siteplanSettings && project.siteplanSettings.siteplanSimpleMode === true
        && unit.statusID !== 'new')));
};
